// ** React Imports
import { Fragment, useState } from 'react'
import { Info } from 'react-feather'

// ** Reactstrap Imports
import { Button, Tooltip } from 'reactstrap'

const TooltipControlled = ({ targetId, tooltipContent }) => {
  // ** State
  const [tooltipOpen, setTooltipOpen] = useState(false)

  return (
    <Fragment>
      <span id={targetId}>
        <Info size={15}/>
      </span>
      <Tooltip
        placement='top'
        isOpen={tooltipOpen}
        target={targetId}
        toggle={() => setTooltipOpen(!tooltipOpen)}
      >
        {tooltipContent}
      </Tooltip>
    </Fragment>
  )
}
export default TooltipControlled
